import { RefreshButton } from '@/components/layout/Navigation/sessions/header/toolbar/refresh';
import { SessionsSort } from '@/components/layout/Navigation/sessions/header/toolbar/sort';
import { sessionListHost } from '@/composition/hosts/session/session-list/session-list-host';
import { SessionsFilters } from '@heidi/session';
import { SearchButton } from './search';

export const SessionsToolbar = () => {
  return (
    <div className="ml-auto hidden items-center sm:flex">
      <SessionsFilters host={sessionListHost} />
      <SessionsSort />
      <SearchButton />
      <RefreshButton />
    </div>
  );
};
